module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vrepr1-211d626a880163c44f18c6eab28870a4.jpg";